import {EagleApiInterface, EagleModuleApiInterface} from 'kernel/api/api'

export default (api: EagleApiInterface) => {
  api.collection.contactApi = <EagleModuleApiInterface>{
    read: (id: string) => api.request({
      url: `/api/admin/contact/${id}`,
      type: 'get',
    }),
    index: (params = {}) => api.request({
      url: `/api/admin/contact/index`,
      type: 'get',
      params,
    }),
    create: (params = {}) => api.request({
      url: `/api/admin/contact`,
      type: 'post',
      params,
    }),
    reply: (id, params = {}) => api.request({
      url: `/api/admin/contact/${id}/reply`,
      type: 'post',
      params,
    }),
    update: (id: string, params = {}) => api.request({
      url: `/api/admin/contact/${id}/update`,
      type: 'put',
      params,
    }),
    patch: (id: string, column: string, value: any) => api.request({
      url: `/api/admin/contact/${id}`,
      type: 'patch',
      params: {
        column,
        value,
      },
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/contact/${id}`,
      type: 'delete',
    }),
    batch: (targets: string[], column: string, value: any) => api.request({
      url: `/api/admin/contact/batch`,
      type: 'patch',
      params: {
        ids: targets,
        column,
        value,
      },
    }),
    batchDelete: (targets: string[]) => api.request({
      url: `/api/admin/contact/batch`,
      type: 'delete',
      params: { ids: targets },
    }),
  }

  api.collection.contactCommentApi = <EagleModuleApiInterface>{
    read: (id: string) => api.request({
      url: `/api/admin/contact-comment/${id}`,
      type: 'get',
    }),
    index: (params = {}) => api.request({
      url: `/api/admin/contact-comment/index`,
      type: 'get',
      params,
    }),
    create: (params = {}) => api.request({
      url: `/api/admin/contact-comment`,
      type: 'post',
      params,
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/contact-comment/${id}`,
      type: 'delete',
    }),
    batchDelete: (targets: string[]) => api.request({
      url: `/api/admin/contact-comment/batch`,
      type: 'delete',
      params: { ids: targets },
    }),
  }
}
